import React from 'react';
import { useNavigate } from 'react-router-dom';

const HomePage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-400 to-blue-500 flex flex-col items-center justify-center p-4">
      <h1 className="text-5xl font-bold text-white mb-8">Welcome to Quiz Game</h1>
      <div className="flex flex-col md:flex-row gap-6">
        <button
          onClick={() => navigate('/create-room')}
          className="px-8 py-4 bg-yellow-500 hover:bg-yellow-600 text-white font-bold text-lg rounded-lg shadow-lg transition-all duration-200"
        >
          Create Room
        </button>
        <button
          onClick={() => navigate('/join-room')}
          className="px-8 py-4 bg-purple-500 hover:bg-purple-600 text-white font-bold text-lg rounded-lg shadow-lg transition-all duration-200"
        >
          Join Room
        </button>
      </div>
    </div>
  );
};

export default HomePage;
